<template>
    <div class="app">
        <!--面包屑导航区域-->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>公式管理</el-breadcrumb-item>
            <el-breadcrumb-item>公式列表</el-breadcrumb-item>
        </el-breadcrumb>
        <!--卡片视图区域-->
        <el-card class="el-card">
            <el-row :gutter="20">
                <!--搜索与添加区域-->
                <el-col :span="6">
                    <el-input placeholder="请输入公式名称" v-model="queryInfo.inputName" clearable @clear="getformulaList">
                    </el-input>
                </el-col>
                <!--搜索按钮-->
                <el-col :span="3">
                    <el-button type="primary" icon="el-icon-search" @click="getFormulaList">{{$t('common.search')}}</el-button>
                </el-col>

                <el-col :span="2" style="float: right">
                    <el-button type="primary" icon="el-icon-plus" @click="openAddFormulaInfo">{{$t('common.add')}}</el-button>
                </el-col>
            </el-row>
            <!--公式区域-->
            <el-table :data="formulaList.records" border stripe style="width: 100%" v-loading="loading">
                <el-table-column label="公式ID" prop="methodId" align="center"></el-table-column>
                <el-table-column label="公式名称" prop="name" align="center"></el-table-column>
                <el-table-column label="公式参数" prop="methodParams" align="center"></el-table-column>
                <el-table-column label="公式描述" prop="descb" align="center"></el-table-column>
                <el-table-column label="创建时间" prop="creationTime" align="center"></el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <!--修改-->
                        <el-tooltip effect="dark" content="修改" placement="top" :enterable="false">
                            <el-button type="primary" icon="el-icon-edit" size="mini"
                                       @click="showEditDialog(scope.row)"></el-button>
                        </el-tooltip>
                        <!--删除-->
                        <el-tooltip effect="dark" content="删除" placement="top" :enterable="false">
                            <el-button type="danger" icon="el-icon-delete" size="mini"
                                       @click="removeFormulaById(scope.row)"></el-button>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <!--分页区域-->
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="queryInfo.pageNum"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="queryInfo.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="formulaList.total">
            </el-pagination>
        </el-card>
        <!--修改公式的对话框-->
        <el-dialog
                title="修改公式"
                :visible.sync="editDialogVisible"
                width="900px">
            <!--内容主体区域-->
            <el-form :model="editFormulaForm" ref="editOrderRef" label-width="100px" :inline="true">
                <el-form-item label="公式id" prop="methodId">
                    <el-input v-model="editFormulaForm.methodId" disabled style="width: 300px"></el-input>
                </el-form-item>
                <el-form-item label="公式名称" prop="name" style="width: 400px">
                    <el-input v-model="editFormulaForm.name" style="width: 300px"></el-input>
                </el-form-item>
                <el-form-item label="公式参数" prop="methodParams">
                    <el-input v-model="editFormulaForm.methodParams" style="width: 300px"></el-input>
                </el-form-item>
                <el-form-item label="公式描述" prop="descb">
                    <el-input type="textarea" :rows="4" v-model="editFormulaForm.descb" style="width: 700px"></el-input>
                </el-form-item>
                <!--<el-form-item label="边界值min" prop="min" style="width: 400px">-->
                    <!--<el-input type="number" v-model="editFormulaForm.min" style="width: 300px"></el-input>-->
                <!--</el-form-item>-->
                <!--<el-form-item label="边界值max" prop="max">-->
                    <!--<el-input type="number" v-model="editFormulaForm.max" style="width: 300px"></el-input>-->
                <!--</el-form-item>-->
                <el-form-item label="算法识别码" prop="identifyingCode">
                    <el-select v-model="editFormulaForm.identifyingCode" @change="changemethod" style="width: 700px" placeholder="请选择">
                        <el-option
                                v-for="item in options"
                                :key="item.methodIdentifyingCode"
                                :label="item.methodIdentifyingCode"
                                :value="item.methodIdentifyingCode">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="" prop="">
                    {{methodIdentifyingDescribe}}
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
    <el-button @click="editDialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="editFormulaInfo">确 定</el-button>
  </span>
        </el-dialog>
        <el-dialog
                title="增加公式"
                :visible.sync="addDialogVisible"
                width="900px">
            <el-form :model="addFormulaForm" label-width="100px" :inline="true">
<!--                <el-form-item label="公式id" prop="methodId">-->
<!--                    <el-input v-model="addFormulaForm.methodId" style="width: 300px"></el-input>-->
<!--                </el-form-item>-->
                <el-form-item label="公式名称" prop="name" style="width: 400px">
                    <el-input v-model="addFormulaForm.name" style="width: 300px"></el-input>
                </el-form-item>
                <el-form-item label="公式参数" prop="methodParams">
                    <el-input v-model="addFormulaForm.methodParams" style="width: 300px"></el-input>
                </el-form-item>
                <el-form-item label="公式描述" prop="descb">
                    <el-input type="textarea" :rows="4" v-model="addFormulaForm.descb" style="width: 700px"></el-input>
                </el-form-item>
                <!--<el-form-item label="边界值min" prop="min" style="width: 400px">-->
                    <!--<el-input type="number" v-model="addFormulaForm.min" style="width: 300px"></el-input>-->
                <!--</el-form-item>-->
                <!--<el-form-item label="边界值max" prop="max">-->
                    <!--<el-input type="number" v-model="addFormulaForm.max" style="width: 300px"></el-input>-->
                <!--</el-form-item>-->
                <el-form-item label="算法识别码" prop="identifyingCode">
                    <el-select v-model="addFormulaForm.identifyingCode" @change="changemethod" placeholder="请选择">
                        <el-option
                                v-for="item in options"
                                :key="item.methodIdentifyingCode"
                                :label="item.methodIdentifyingCode"
                                :value="item.methodIdentifyingCode">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="" prop="">
                    <el-tag size="small"> {{methodIdentifyingDescribe}}</el-tag>
                </el-form-item>

            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="addFormulaInfo">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "formulaList",
        data() {
            return {
                loading:false,
                options: [],
                methodIdentifyingDescribe:'',
                queryInfo: {
                    pageNum: 1,
                    pageSize: 10
                },
                formulaList: {
                    records: [],
                    total: 0
                },
                // 控制添加公式弹框的显示和隐藏
                addDialogVisible: false,
                // 控制修改公式对话框的显示与隐藏
                editDialogVisible: false,
                addMethodDialogVisible: false,
                addFormulaForm: {},
                // 修改的公式对象
                editFormulaForm: {},
                dialogImageUrl: '',
                dialogVisible: false,
            }
        },
        created() {
            this.getFormulaList();
            this.getBrix();
        },
        methods: {
            changemethod(event){
            for(let i = 0;i<this.options.length;i++){
                if(this.options[i].methodIdentifyingCode === event){
                     this.methodIdentifyingDescribe=this.options[i].methodIdentifyingDescribe
                }
            }
            },
            // 获取算法识别码
            async getBrix(){
                let {data: res} = await this.$http.post(`/brix/brixList`,{});
                if (res.code !== 1) return this.$message.error(res.msg);
                this.options= res.data;
            },
            // 获取公式列表
            async getFormulaList() {
                this.loading = true
                let {data: res} = await this.$http.post(`/api/formula/selectPage`, this.queryInfo);
                if (res.code !== 1) return this.$message.error(res.msg);
                this.formulaList.records = res.data.records;
                this.formulaList.total = res.data.total;
                this.loading = false
            },
            // 监听pageSize改变的事件
            handleSizeChange(newSize) {
                this.queryInfo.pageSize = newSize;
                this.getFormulaList()
            },
            // 监听pageNum改变的事件
            handleCurrentChange(newPage) {
                this.queryInfo.pageNum = newPage;
                this.getFormulaList()
            },


            // 展示修改公式的对话框
            async showEditDialog(formula) {
                // const {data: res} = await this.$http.post(`/api/formula/getById`, formula);
                // if (res.code !== 1) return this.$message.error("查询公式失败");
                this.editFormulaForm = formula;
                this.methodIdentifyingDescribe = ''
                this.editDialogVisible = true;
            },


            // 修改公式信息并提交
            async editFormulaInfo() {
                const {data: res} = await this.$http.post(`/api/formula/addFormula`, this.editFormulaForm);
                if (res.code !== 1) return this.$message.error(res.msg);
                this.$message.success("修改公式成功");
                // 隐藏添加公式对话框
                this.editDialogVisible = false;
                // 重新获取公式列表
                this.getFormulaList();
            },

            // 根据id删除公式信息
            async removeFormulaById(formula) {
                // 弹框询问用户是否删除公式
                await this.$confirm('此操作将永久删除该公式, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    // 删除公式
                    const {data: res} = await this.$http.post(`/api/formula/removeById`, formula);
                    if (res.code !== 1) return this.$message.error("删除失败");
                    this.$message.success("删除成功");
                    // 重新获取公式列表
                    this.getFormulaList();
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            /**
             * 新增公式
             */
            async addFormulaInfo() {
                if (this.addFormulaForm.name == "" || this.addFormulaForm.name == undefined) {
                    this.$message.error("请输入公式名")
                    return
                }
                if (this.addFormulaForm.descb == "" || this.addFormulaForm.descb == undefined) {
                    this.$message.error("请输入公式描述")
                    return
                }
                // if (this.addFormulaForm.creationTime == "" || this.addFormulaForm.creationTime == undefined) {
                //     this.$message.error("请输入创建时间")
                //     return
                // }
                let params = this.addFormulaForm;
                params.methodId = new Date().getTime();
                const {data: res} = await this.$http.post(`/api/formula/addFormula`, params);
                if (res.code !== 1) {
                    return this.$message.error("增加失败");
                } else {
                    this.addDialogVisible = false;
                    this.getFormulaList();
                    return this.$message.success("增加成功");
                }
            },
            /**
             * 打开新增公式的弹框
             */
            openAddFormulaInfo() {
                this.addFormulaForm = {}
                this.methodIdentifyingDescribe = ''
                this.addDialogVisible = true
            }
        }
    }
</script>

<style lang="less" scoped>
    .el-table {
        margin-top: 15px;
        font-size: 12px;
    }

    .el-pagination {
        margin-top: 15px;
    }

    .app .el-card {
        width: 99%;
    }
</style>
